// extracted by mini-css-extract-plugin
export var divider = "_rt-0";
export var systemMessage = "_rt-1";